export default {
  head: [
    {
      name: "NHP Home",
      path: "/",
    },
    {
      name: "HMS Home",
      path: "/webgis-vic",
      active: true,
    },
    {
      name: "Objective",
      path: "/webgis-vic/proj-obj",
    },
    {
      name:'Download Products',
      path:'/nhp-data-download'
    },
    {
      name:'Soil Moisture In-situ Data',
      path:'/vic-soil-moisture-dashboard'
    }
    // {
    //     name:"Technical Proposal",
    //     path:"/webgis-vic/tech-prop"

    // },
    // {
    //     name:"Project Team",
    //     path:"/webgis-vic/proj-team"

    // },
    // {
    //     name:"Financial Proposal",
    //     path:"/webgis-vic/fin-prop"
    // }
  ],

  breadCrumbs: [
    {
      name: "NHP Home",
      path: "/nhp-home",
    },
    {
      name: "HMS Home",
      path: "/",
      active: true,
    },
    {
      name: "Objective",
      path: "/vic/proj-obj",
    },
    {
      name: "Technical Proposal",
      path: "/vic/tech-prop",
    },
    {
      name: "Project Team",
      path: "/vic/proj-team",
    },
  ],

  mapSideBar: [
    {
      id: 1,
      name: "Hydrological Science",
      displayname: "Hydrological Modelling Systems",
      icon: "stroopwafel",
      popup: true,
      //  "info":"",
      active: false,
    
    },
    {
      id: 2,
      name: "Precipitation",
      icon: "stroopwafel",
      displayname: "Precipitation",
      active: false,
      daily:true,
      // "hasDefault":true,
      children: [
        {
          id: 1,
          name: "Rainfall",
          icon: "stroopwafel",
          ismap: true,
          displayname: "Rainfall",
          default: true,
        },
        // {
        //     "id": 2,
        //     "name": 'GPM Rainfall',
        //     "icon":"stroopwafel",
        //     "ismap":true,

        // },
      ],
    },

    {
      id: 3,
      name: "Runoff",
      displayname: "Runoff",
      icon: "stroopwafel",
      active: true,
      default: true,
      daily:true,
      hasDefault: true,
      children: [
        {
          id: 1,
          name: "#",
          icon: "stroopwafel",
          ismap: true,
          default: true,
        },
        // {
        //     "id": 2,
        //     "name": 'GPM Rainfall',
        //     "icon":"stroopwafel",
        //     "ismap":true,

        // },
      ],
    },
    {
      id: 4,
      name: "Evapotranspiration",
      icon: "stroopwafel",
      active: false,
      daily:true,
      displayname: "Evapotranspiration",
      children: [
        // {
        //     "id": 1,
        //     "name": 'Potential Evapotranspiration',
        //     "icon":"stroopwafel",
        //     "ismap":true,

        // },
        {
          id: 2,
          name: "Actual Evapotranspiration",
          displayname: "Actual Evapotranspiration",
          icon: "stroopwafel",
          ismap: true,
          default: true,
        },
        // {
        //     "id": 3,
        //     "name": 'Reference Crop Evapotranspiration',
        //     "icon":"stroopwafel",
        //     "ismap":true,

        // },
        // {
        //     "id": 4,
        //     "name": 'Evapotranspiration from Open Water Bodies',
        //     "icon":"stroopwafel",
        //     "ismap":true,

        // },
      ],
    },
    {
      id: 6,
      name: "Soil Moisture",
      displayname: "Soil Moisture",
      active: false,
      daily:true,
      icon: "stroopwafel",
      children: [
        {
          id: 1,
          name: "Root Zone Soil Moisture (0 - 50 cm)",
          displayname: "Root Zone Soil Moisture (0 - 50 cm)",
          icon: "stroopwafel",
          ismap: true,
          default: true,
        },
        {
          id: 2,
          name: "Upper Soil Moisture (0 - 15 cm)",
          displayname: "Upper Soil Moisture (0 - 15 cm)",
          icon: "stroopwafel",
          ismap: true,
        },
        {
          id: 3,
          name: "Lower Soil Moisture (15 - 50 cm)",
          displayname: "Lower Soil Moisture (15 - 50 cm)",
          icon: "stroopwafel",
          ismap: true,
        },
        {
          id: 4,
          name: "Deep Soil Moisture (50 - 150 cm)",
          displayname: "Deep Soil Moisture (50 - 150 cm)",
          icon: "stroopwafel",
          ismap: true,
        },
      ],
    },

    {
      id: 7,
      name: "Forecast Surface Runoff",
      displayname: "Forecast Surface Runoff",
      icon: "stroopwafel",
      active: false,
      forecast: true,

      children: [
        {
          id: 1,
          name: 1,
          displayname: 1,
          icon: "stroopwafel",
          ismap: true,
          default: true,
        },
        {
          id: 2,
          name: 2,
          displayname: 2,
          icon: "stroopwafel",
          ismap: true,
        },
        {
          id: 3,
          name: 3,
          displayname: 3,
          icon: "stroopwafel",
          ismap: true,
        },
      ],
    },
    {
      id: 8,
      name: "smai",
      displayname: "Soil Moisture Availability Index",
      active: false,
      smaienabled:true,
      icon: "stroopwafel",
      children: [
        {
          id: 1,
          name: "weekly",
          displayname: "Weekly",
          icon: "stroopwafel",
          ismap: true,
          weekly:true,
          default: true,
        },
        {
          id: 2,
          name: "monthly",
          displayname: "Monthly",
          icon: "stroopwafel",
          monthly:true,
          ismap: true,

        },
      
      ],
    },

    // {
    //   id: 8,
    //   name: "Standardized Precipitation Index (SPI)",
    //   icon: "stroopwafel",
    //   displayname: "Standardized Precipitation Index (SPI)",
    //   noGraph: true,
    //   disabled: true,
    //   active: false,
    //   children: [
    //     {
    //       id: 1,
    //       name: "1 Month",
    //       icon: "stroopwafel",
    //       displayname: "1 Month",
    //       ismap: true,
    //     },
    //     {
    //       id: 2,
    //       name: "3 Month",
    //       icon: "stroopwafel",
    //       displayname: "3 Month",
    //       ismap: true,
    //     },
    //     {
    //       id: 3,
    //       name: "6 Month",
    //       displayname: "6 Month",
    //       icon: "stroopwafel",
    //       ismap: true,
    //     },
    //     {
    //       id: 4,
    //       name: "12 Month",
    //       displayname: "12 Month",
    //       icon: "stroopwafel",
    //       ismap: true,
    //     },
    //   ],
    // },
    // {
    //   id: 9,
    //   name: "Standardized Runoff Index (SRI)",
    //   displayname: "Standardized Runoff Index (SRI)",
    //   icon: "stroopwafel",
    //   noGraph: true,
    //   disabled: true,
    //   active: false,
    //   children: [
    //     {
    //       id: 1,
    //       name: "1 Month",
    //       displayname: "1 Month",
    //       icon: "stroopwafel",
    //       ismap: true,
    //     },
    //     {
    //       id: 2,
    //       name: "3 Month",
    //       displayname: "3 Month",
    //       icon: "stroopwafel",
    //       ismap: true,
    //     },
    //     {
    //       id: 3,
    //       name: "6 Month",
    //       displayname: "6 Month",
    //       icon: "stroopwafel",
    //       ismap: true,
    //     },
    //     {
    //       id: 4,
    //       name: "12 Month",
    //       displayname: "12 Month",
    //       icon: "stroopwafel",
    //       ismap: true,
    //     },
    //   ],
    // },
    // {
    //   id: 10,
    //   name: "Soil Moisture Adequacy Index",
    //   displayname: "Soil Moisture Adequacy Index",
    //   icon: "stroopwafel",
    //   ismap: true,
    //   disabled: true,
    //   active: false,
    //   popup: true,
    // },
    {
      id: 11,
      name: "Inflows into major reservoirs",
      displayname: "Inflows into Major Reservoirs",
      icon: "stroopwafel",
      // ismap: true,
      geojson: true,
      popup: true,
      active: false,
      children:[
        {
                id: 1,
                name: "ic",
                displayname: "Independent Catchment",
                icon: "stroopwafel",
                geojson: true,
                default: true,
              },
              {
                id: 2,
                name: "tc",
                displayname: "Total Catchment",
                icon: "stroopwafel",
                geojson: true,
              },
              {
                id: 3,
                name: "tuc",
                displayname: "Abstracted Flows",
                icon: "stroopwafel",
                geojson: true,
              },
      ]
      //"disabledate":true,
      //"noGraph":true,
      // "indicator":true,
    },
    // {
    //   id: 12,
    //   name: "Snowmelt Runoff",
    //   displayname: "Snowmelt Runoff",
    //   icon: "stroopwafel",
    //   ismap: false,
    //   popup: true,
    //   active: false,
    //   // "dateRequired": true,
    //   disabled: true,
    // },
    // {
    //   id: 13,
    //   name: "Basin Scale Fluxes",
    //   displayname: "Basin Scale Fluxes",
    //   icon: "stroopwafel",
    //   // "ismap":false,
    //   popup: true,
    //   active: false,
    //   // "dateRequired": true,

    //   disabled: true,
    //   // "children": [
    //   //     {
    //   //         "id": 1,
    //   //         "name": 'Rainfall',
    //   //         "icon":"stroopwafel",
    //   //         "ismap":true,

    //   //     },
    //   //     {
    //   //         "id": 2,
    //   //         "name": 'Runoff',
    //   //         "icon":"stroopwafel",
    //   //         "ismap":true,

    //   //     },
    //   //     {
    //   //         "id": 3,
    //   //         "name": 'Evapotranspiration',
    //   //         "icon":"stroopwafel",
    //   //         "ismap":true,

    //   //     },
    //   //     {
    //   //         "id": 4,
    //   //         "name": 'Soil Moisture',
    //   //         "icon":"stroopwafel",
    //   //         "ismap":true,

    //   //     },

    //   // ]
    // },

    // {
    //   id: 14,
    //   name: "Irrigation Requirement",
    //   displayname: "Irrigation Requirement",
    //   icon: "stroopwafel",
    //   // "ismap":false,
    //   active: false,
    //   disabled: true,
    //   popup: true,
    // },
  ],
};
